import {
    FETCH_PRICE_GROUPS_LIST_REQUEST,
    FETCH_PRICE_GROUPS_LIST_SUCCESS,
    FETCH_PRICE_GROUPS_LIST_FAILURE,
  } from "./FetchPriceGroupListTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchPricegroupsListRequest = () => {
    return {
      type: FETCH_PRICE_GROUPS_LIST_REQUEST,
    };
  };
  
  export const fetchPricegroupsListSuccess = (pricegroupsList) => {
    return {
      type: FETCH_PRICE_GROUPS_LIST_SUCCESS,
      payload: pricegroupsList,
    };
  };
  
  export const fetchPricegroupsListFailure = (error) => {
    return {
      type: FETCH_PRICE_GROUPS_LIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchPricegroupsList = (discipline_code) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/pricegroup/list?discipline_code=" + discipline_code;

    return async (dispatch) => {
      dispatch(fetchPricegroupsListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
  
        const pricegroupsList = response.data.data;
        dispatch(fetchPricegroupsListSuccess(pricegroupsList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchPricegroupsListFailure(errorMsg));
      }
    };
  };
  